import { IPayroll } from '../../types/payroll';
import GeneralEnumService from '../../enumerables/general-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';
import { changeToZeroMoment } from '../timeHelpers';
import { numberWithCommas } from '../format';

export const groupDataToCsv = (data: IPayroll[]): string[][] => {
    const groupData: string[][] = [
        [
            'Payroll ID',
            'Employee ID',
            'Provider',
            'Payroll Date',
            'Payroll Total',
            'Period Start',
            'Period End',
            'Hours',
            'Note',
            'Status',
        ],
    ];
    const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('PayrollStatus') : {};
    const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);

    data.forEach((it) => {
        const payrollDate = it.payrollDate ? changeToZeroMoment(it.payrollDate, 'MMM D, YYYY') : '';
        const totalPaid: string = it?.totalPaid ? `$${numberWithCommas(it.totalPaid)}` : '0';
        const id: string = it?.id ? `${it.id}` : '0';
        const note: string = it?.note ? `${it.note}` : '';
        const provider: string = it?.provider?.fullName ? `${it?.provider?.fullName}` : '';
        const employeeId: string = it?.provider?.employeeId ? `${it?.provider?.employeeId}` : '';
        const periodStart = it['periodStart'] ? changeToZeroMoment(it['periodStart'], 'MMM D, YYYY') : '';
        const endPeriod = it['periodEnd'] ? changeToZeroMoment(it['periodEnd'], 'MMM D, YYYY') : '';
        const hoursAdminAndConfirm: string = it?.hoursAdminAndConfirm ? `${it.hoursAdminAndConfirm}` : '';
        let valueStatus: string | SelectObject | undefined = statusItems.find((its) => +its.value === +it.status);
        valueStatus = valueStatus ? `${valueStatus?.label}` : '';

        groupData.push([
            id,
            employeeId,
            provider,
            payrollDate,
            totalPaid,
            periodStart,
            endPeriod,
            hoursAdminAndConfirm,
            note,
            valueStatus,
        ]);
    });

    return groupData;
};
